// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__FmPDK","badgeDot":"styles_badgeDot__WZngp","badgeText":"styles_badgeText__HfBaw"};